document.addEventListener("DOMContentLoaded", function() {
      if (window.innerWidth <= 767) { 
          var descriptions = document.querySelectorAll('.product-description'); 

          descriptions.forEach(function(description) {
              var fullText = description.innerHTML;
              if (fullText.length > 200) {
                  var truncatedText = fullText.slice(0, 280);
                  var readMoreButton = document.createElement('span');
                  readMoreButton.className = 'read-more';
                  readMoreButton.style.color = '#ec1a23';
                  readMoreButton.style.cursor = 'pointer';
                  readMoreButton.innerHTML = '... Read More';

                  var readLessButton = document.createElement('span');
                  readLessButton.className = 'read-less';
                  readLessButton.style.color = '#ec1a23';
                  readLessButton.style.cursor = 'pointer';
                  readLessButton.innerHTML = ' Read Less';
                  readLessButton.style.display = 'none';

                  description.innerHTML = truncatedText;
                  description.appendChild(readMoreButton);
                  description.appendChild(readLessButton);

                  readMoreButton.addEventListener('click', function() {
                      description.innerHTML = fullText;
                      description.appendChild(readLessButton);
                      readLessButton.style.display = 'inline';
                      readMoreButton.style.display = 'none';
                  });

                  readLessButton.addEventListener('click', function() {
                      description.innerHTML = truncatedText;
                      description.appendChild(readMoreButton);
                      readMoreButton.style.display = 'inline';
                      readLessButton.style.display = 'none';
                  });
              }
          });
      }
  });